module.exports = __webpack_public_path__ + "img/infor_bg.5d50d615.png";